import { Text } from '@/components/typography';
import { numberFormat } from '@/helper/numberFormatter';
import { cn } from '@/lib/utils';

type Props = {
  width: number;
};

const BenchmarksChartAxis = ({ width }: Props) => {
  const isCompact = width < 400;
  const tickPositions = isCompact ? [0, 0.5, 1] : [0, 0.25, 0.5, 0.75, 1];

  return (
    <div className={cn('mx-5 border-b border-gray-200 pr-2 pl-32.5', isCompact && 'pl-2')}>
      <div className="relative h-7">
        {tickPositions.map((position) => (
          <Text
            key={position}
            className="absolute -translate-x-1/2 text-gray-600 first:translate-x-0 last:-translate-x-full"
            variant="caption1"
            style={{ left: `${position * 100}%` }}
          >
            {numberFormat(position, { isPercent: true, precision: 0 })}
          </Text>
        ))}
      </div>
    </div>
  );
};

export default BenchmarksChartAxis;
